import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react'; // Renders a checkerboard pattern using CSS gradients

import { jsx as _jsx } from "react/jsx-runtime";

const Checkboard = _ref => {
  let {
    size,
    white,
    grey
  } = _ref;
  const backgroundStyle = {
    // Set the base background color
    backgroundColor: white,
    // Create the checkerboard pattern
    backgroundImage: `
      linear-gradient(45deg, ${grey} 25%, transparent 25%),
      linear-gradient(-45deg, ${grey} 25%, transparent 25%),
      linear-gradient(45deg, transparent 75%, ${grey} 75%),
      linear-gradient(-45deg, transparent 75%, ${grey} 75%)
    `,
    // Set the background pattern size to twice the square size.
    backgroundSize: `${size * 2}px ${size * 2}px`,
    // Adjust the position of each gradient to align the squares correctly
    backgroundPosition: `0 0, 0 ${size}px, ${size}px -${size}px, -${size}px 0px`
  };
  return /*#__PURE__*/_jsx("div", {
    style: _objectSpread(_objectSpread({}, backgroundStyle), {}, {
      width: '100%',
      height: '100%',
      position: 'absolute',
      pointerEvents: 'none'
    })
  });
};

export default Checkboard;